import createReducer from 'utils/redux/createReducer'
import * as R from 'ramda'

const initialState = {
	mode: 'view'
  , commentID: ""
  , contents: null
}

export default createReducer(initialState, {
	'COMMENT_ADD': (currentState, action) => ({
		...currentState
	  , mode: 'new'
	  , commentID: action._id
	  , objectID: action.data
	  , type: "comment"
	})
  , 'COMMENT_CHANGE': (currentState, action) => ({
		...currentState
	  , contents: action.data
  })
  , 'COMMENT_EDIT': (currentState, action) => ({
		...currentState
	  , mode: 'edit'
	  , commentID: action.data._id
	  , contents: action.data.contents
	})
  , 'COMMENT_SAVE': (currentState,) => ({
		mode: 'view'
	  , commentID: ""
  	  , contents: null
  })
  , 'COMMENT_DISCARD': (currentState) => ({
		mode: 'view'
	  , commentID: ""
  	  , contents: null
  })
  , '@@router/LOCATION_CHANGE': (currentState) => ({
		mode: 'view'
	  , commentID: ""
  	  , contents: null
  })
  , 'CHOOSE_ITEM': (currentState) => ({
		mode: 'view'
	  , commentID: ""
  	  , contents: null
  })
})



// WEBPACK FOOTER //
// ./src/reducers/commentBuffer.js